import { Modal as BootstrapModal } from 'react-bootstrap';
import { Typography } from 'app/components/ui';
import { i18n } from 'app/utils/i18n';

import 'app/components/editor/sidebar/tags/Modal/Modal.scss';

interface DeleteBlockModalProps {
  show: boolean;
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export const DeleteBlockModal = ({ show, message, onConfirm, onCancel }: DeleteBlockModalProps) => {
  return (
    <BootstrapModal show={show} onHide={onCancel} contentClassName="tags-modal__content tags-modal__content--continuation" centered>
      <button onClick={onCancel} type="button" aria-label="Close" className="tags-modal__close-btn">
        <i className="fa-solid fa-xmark" />
      </button>

      <div className="tags-modal__header">
        <i className="fa-solid fa-trash tags-modal__tag-icon tags-modal__tag-icon--danger" />

        <div className="tags-modal__title-group">
          <Typography variant="body-7" fontWeight="semibold" color="#1e2533">
            {i18n('block.delete.modal.title')}
          </Typography>

          <Typography variant="body-7" fontWeight="light" color="#616066">
            {message}
          </Typography>
        </div>
      </div>

      <div className="tags-modal__actions">
        <button className="tags-modal__btn-cancel" onClick={onCancel}>
          {i18n('block.delete.modal.cancel')}
        </button>
        <button className="tags-modal__btn-confirm tags-modal__btn-confirm--danger" onClick={onConfirm}>
          {i18n('block.delete.modal.confirm')}
        </button>
      </div>
    </BootstrapModal>
  );
};
